import { VRangeSlider } from 'vuetify/lib/components/VRangeSlider';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"range-slider"},[_c('div',{staticClass:"range-slider__label subtitle-2 text-center",class:[
      {
        'range-slider__label--disabled': _vm.disabled
      }
    ]},[_vm._v(" "+_vm._s(_vm.translations.name)+" ")]),_c('div',{staticClass:"range-slider__wrapper"},[_c(VRangeSlider,{staticClass:"align-center",attrs:{"disabled":_vm.disabled,"step":_vm.step,"min":_vm.min,"max":_vm.max,"thumb-label":_vm.thumbLabel},scopedSlots:_vm._u([(!!_vm.thumbLabel)?{key:"thumb-label",fn:function(props){return [_vm._v(" "+_vm._s(props.value)+" ")]}}:null],null,true),model:{value:(_setup.range),callback:function ($$v) {_setup.range=$$v},expression:"range"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }